import { render, staticRenderFns } from "./UpperNav.vue?vue&type=template&id=31ac1d1e&"
import script from "./UpperNav.vue?vue&type=script&lang=js&"
export * from "./UpperNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports